<template>
    <div class="Information">
        <div class="row">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-4">
                        <div class="record-section">
                            <h4>Enrollment Information:</h4>
                            <p>
                                <span class="bold">Program Name: </span> {{ ChildRecordData.SubProgram.Name }}

                            </p>
                            <p>
                                <span class="bold">Enrollment Start Date: </span>
                                <DateEditorRequest v-bind:old-value="ChildRecordData.StartDate"
                                                   v-bind:record-id="ChildRecordData.Id"
                                                   v-bind:edit-mode="EditMode"
                                                   data-label="Start Date"
                                                   property-name="Date"
                                                   update-method="TAY/Clients/UpdateStartDate"
                                                   required="true"
                                                   warning-notice="Modifying the referral date may affect other records, and reports that have already been generated should be updated."
                                                   :global-update="true"
                                                   :chart-id="ChildRecordData.Id"
                                                   edit-permission="TAY/Clients/UpdateStartDate" />
                            </p>
                            <p v-if="ChildRecordData.SubProgramID == 'ebda4d2b-fd9c-4135-804e-5132296063ca'">
                                <span class="bold">First Face-To-Face Date: </span>
                                <DateEditorRequest v-bind:old-value="ChildRecordData.FirstFaceToFaceDate"
                                                   v-bind:record-id="ChildRecordData.Id"
                                                   v-bind:edit-mode="EditMode"
                                                   data-label="first Face-To-Face Date"
                                                   property-name="FirstFaceToFaceDate"
                                                   update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                                   :required="false"
                                                   global-update="true"
                                                   :chart-id="ChildRecordData.Id" />
                            </p>
                            <p>
                                <span class="bold">Agency: </span>
                                <SelectEditor v-bind:old-value="ChildRecordData.AgencyID"
                                              v-bind:old-value-text="ChildRecordData.PlacementAgency.Name"
                                              v-bind:record-id="ChildRecordData.Id"
                                              v-bind:edit-mode="EditMode"
                                              data-label="Placement Agency"
                                              property-name="AgencyID"
                                              update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                              :chart-id="ChildRecordData.Id"
                                              v-bind:options="AgencyOptions" />
                            </p>
                            <p>
                                <span class="bold">Termination Info: </span>
                                <DischargeEditor v-bind:old-end-date="ChildRecordData.EndDate"
                                                 v-bind:old-reason="ChildRecordData.SubProgramDischargeReason"
                                                 v-bind:record-id="ChildRecordData.Id"
                                                 record-id-name="ClientSubProgramMembershipID"
                                                 v-bind:edit-mode="EditMode"
                                                 data-label="Termination Info"
                                                 discharge-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/TerminateSubProgramMembership"
                                                 revert-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/RevertSubProgramTermination"
                                                 v-bind:options="GetSubProgramTerminationReasons"
                                                 discharge-language="Terminate"
                                                 :chart-id="ChildRecordData.Id"
                                                 edit-permission="Tay.UpdateTermination" />
                            </p>
                            <p>
                                <span class="bold">Days in Program: </span><span>{{ ChildRecordData.DaysInSubProgram }}</span>
                            </p>
                        </div>

                    </div>
                    <div class="col col-md-4">
                        <div class="record-section">
                            <h4>Misc:</h4>
                            <p>
                                <span class="bold">Primary Language Spoken: </span>
                                <SelectEditor v-bind:old-value="ChildRecordData.PrimaryLanguageSpoken"
                                              v-bind:old-value-text="ChildRecordData.PrimaryLanguageSpoken"
                                              v-bind:record-id="ChildRecordData.Id"
                                              v-bind:edit-mode="EditMode"
                                              data-label="Primary Language Spoken"
                                              property-name="PrimaryLanguageSpoken"
                                              update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                              :chart-id="ChildRecordData.Id"
                                              v-bind:options="PrimaryLanguageSpokenOptions" />
                            </p>
                            <p>
                                <span class="bold">Discussed Fire and Evacuation Safety w/ Youth? </span>
                                <SelectEditor v-bind:old-value="ChildRecordData.DiscussedFireAndEvacuationSafety"
                                              v-bind:old-value-text="ChildRecordData.DiscussedFireAndEvacuationSafety ? 'Yes' : 'No'"
                                              v-bind:record-id="ChildRecordData.Id"
                                              v-bind:edit-mode="EditMode"
                                              data-label="Discussed Fire and Evacuation Safety w/ Youth?"
                                              property-name="DiscussedFireAndEvacuationSafety"
                                              update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                              :chart-id="ChildRecordData.Id"
                                              v-bind:options="[{text:'', value:null},{text:'Yes', value:true},{text:'No', value:false}]" />
                            </p>
                            <p>
                                <span class="bold">Extended Foster Care? </span>
                                <SelectEditor v-bind:old-value="ChildRecordData.IsExtendedFosterCare"
                                              v-bind:old-value-text="ChildRecordData.IsExtendedFosterCare"
                                              v-bind:record-id="ChildRecordData.Id"
                                              v-bind:edit-mode="EditMode"
                                              data-label="Youth is Extended Foster Care"
                                              property-name="IsExtendedFosterCare"
                                              update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                              :chart-id="ChildRecordData.Id"
                                              v-bind:options="[{text:'', value:null},{text:'True', value:true},{text:'False', value:false}]" />
                            </p>
                            <p>
                                <span class="bold">Pregnant/Parenting Status </span>
                                <SelectEditor v-bind:old-value="ChildRecordData.ParentalStatus"
                                              v-bind:old-value-text="ChildRecordData.ParentalStatus"
                                              v-bind:record-id="ChildRecordData.Id"
                                              v-bind:edit-mode="EditMode"
                                              data-label="Youth's Pregnant/Parenting Status"
                                              property-name="ParentalStatus"
                                              update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                              :chart-id="ChildRecordData.Id"
                                              v-bind:options="[{text:'', value:null},{text:'Pregnant', value:'Pregnant'},{text:'Parenting', value:'Parenting'},{text:'Both', value:'Both'},{text:'Neither', value:'Neither'},{text:'Decline Response', value:'Decline Response'}]" />
                            </p>
                            <p>
                                <span class="bold">Opt in to Text Messages? </span>
                                <SelectEditor v-bind:old-value="ChildRecordData.IsOptInForTextMessaging"
                                              v-bind:old-value-text="ChildRecordData.IsOptInForTextMessaging ? 'Yes' : 'No'"
                                              v-bind:record-id="ChildRecordData.Id"
                                              v-bind:edit-mode="EditMode"
                                              data-label="Opt in to Text Messages?"
                                              property-name="IsOptInForTextMessaging"
                                              update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                              :chart-id="ChildRecordData.Id"
                                              view-permission-requirement="TayTextMessaging"
                                              v-bind:options="[{text:'', value:null},{text:'Yes', value:true},{text:'No', value:false}]" />
                            </p>
                            <p>
                                <span class="bold">Has Bank Account: </span>
                                <SelectEditor v-bind:old-value="ChildRecordData.HasBankAccount"
                                              v-bind:old-value-text="ChildRecordData.HasBankAccount ? 'Yes' : 'No'"
                                              v-bind:record-id="ChildRecordData.Id"
                                              v-bind:edit-mode="EditMode"
                                              data-label="Has Bank Account?"
                                              property-name="HasBankAccount"
                                              update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                              :chart-id="ChildRecordData.Id"
                                              v-bind:options="[{text:'', value:null},{text:'Yes', value:true},{text:'No', value:false}]" />
                            </p>
                            <p v-if="ChildRecordData.SubProgramID == 'ebda4d2b-fd9c-4135-804e-5132296063ca'">
                                <span class="bold">SIL Funds Used: </span>
                                <SelectEditor v-bind:old-value="ChildRecordData.SILFundsUsed"
                                              v-bind:old-value-text="ChildRecordData.SILFundsUsed ? 'Yes' : 'No'"
                                              v-bind:record-id="ChildRecordData.Id"
                                              v-bind:edit-mode="EditMode"
                                              data-label="SIL Funds Used?"
                                              property-name="SILFundsUsed"
                                              update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                              :chart-id="ChildRecordData.Id"
                                              v-bind:options="[{text:'', value:null},{text:'Yes', value:true},{text:'No', value:false}]" />
                            </p>
                            <p v-if="ChildRecordData.SubProgramID == 'ebda4d2b-fd9c-4135-804e-5132296063ca'">
                                <span class="bold">Perm Pact Complete: </span>
                                <SelectEditor v-bind:old-value="ChildRecordData.PermPactComplete"
                                              v-bind:old-value-text="ChildRecordData.PermPactComplete ? 'Yes' : 'No'"
                                              v-bind:record-id="ChildRecordData.Id"
                                              v-bind:edit-mode="EditMode"
                                              data-label="Perm Pact Complete?"
                                              property-name="PermPactComplete"
                                              update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                              :chart-id="ChildRecordData.Id"
                                              v-bind:options="[{text:'', value:null},{text:'Yes', value:true},{text:'No', value:false}]" />
                            </p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="record-section">
                            <h4>Running Summary:</h4>
                            <TextAreaEditor v-bind:old-value="ChildRecordData.RunningSummary"
                                            v-bind:record-id="ChildRecordData.Id"
                                            v-bind:edit-mode="EditMode"
                                            data-label="Running Summary"
                                            property-name="RunningSummary"
                                            update-method="Foster/FosterClients/UpdateRunningSummary"
                                            required="false"
                                            :global-update="true"
                                            :chart-id="ChildRecordData.Id" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col col-md-6">
                <div class="record-section" v-if="ChildRecordData.SubProgramID != 'ebda4d2b-fd9c-4135-804e-5132296063ca'">
                    <h4>Rate:</h4>
                    <SingleMembershipEditor :fields="[{name: 'ProgramService.Name', title: 'SERVICE'}, {name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                            :field-data="ProgramServicesCensus"
                                            :chart-id="ChildRecordData.Id"
                                            :edit-mode="EditMode"
                                            select-label="Population:"
                                            options-type="API"
                                            options-method="Core/ProgramService/GetProgramServicesForSubProgram"
                                            :options-method-record-id="ChildRecordData.SubProgramID"
                                            add-record-method="Core/ProgramService/AssignProgramServiceToClientSubProgramMembership"
                                            add-record-record-property-name="ProgramServiceID"
                                            :add-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                            add-record-modal-title="Assign Population at Referral"
                                            transfer-record-method="Core/ProgramService/TransferProgramServiceToClientSubProgramMembership"
                                            transfer-record-record-property-name="ProgramServiceID"
                                            :transfer-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                            transfer-record-modal-title="Transfer to New Population"
                                            transfer-record-effective-date-property-name="StartDate"
                                            delete-record-method="Core/ProgramService/DeleteProgramServiceToClientSubProgramMembership"
                                            :delete-record-additional-payload="{Id: ChildRecordData.Id}"
                                            delete-record-modal-title="Delete Current Population"
                                            delete-record-modal-text="NOTICE: You are about to delete this child's current Population Assignment.  If there was a previous population assigned, that population will be re-activated."
                                            edit-permission="Wraparound.ClientProgram.Edit.Population" />
                </div>
                <div class="record-section" v-if="ChildRecordData.SubProgramID == 'ebda4d2b-fd9c-4135-804e-5132296063ca'">
                    <h4>Program Enrollments:</h4>
                    <PNWILSProgramEditor :child-record-data="ChildRecordData"
                                         :edit-mode="EditMode" />
                </div>
            </div>
            <div class="col col-md-6">
                <div class="record-section">
                    <h4>School:</h4>
                    <SchoolDisplayAndEdit :edit-mode="EditMode"
                                          :global-update="true"
                                          get-endpoint="Residential/Clients/GetSchoolMemberships"
                                          :get-payload="{Id: ChildRecordData.Id }"
                                          add-edit-endpoint="Residential/Clients/AddOrUpdateSchoolMembership"
                                          :add-edit-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                          delete-endpoint="Residential/Clients/DeleteSchoolMembership"
                                          :delete-payload="{Id: ChildRecordData.Id}"
                                          :common-schools="CommonSchools" />
                </div>
            </div>
            <div class="col col-md-6">
                <div class="record-section">
                    <h4>Employment:</h4>
                    <EmployerDisplayAndEdit :edit-mode="EditMode"
                                            :global-update="true"
                                            get-endpoint="TAY/Employers/GetEmployerMemberships"
                                            :get-payload="{Id: ChildRecordData.Id }"
                                            add-edit-endpoint="TAY/Employers/AddOrUpdateEmployerMembership"
                                            :add-edit-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                            delete-endpoint="TAY/Employers/DeleteEmployerMembership"
                                            :delete-payload="{Id: ChildRecordData.Id}" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col col-md-6">
                <div class="record-section">
                    <h4>Education History</h4>
                    <p>
                        <span class="bold">High School Graduation Date: </span>
                        <DateEditorRequest v-bind:old-value="ChildRecordData.HighSchoolGraduationDate"
                                           v-bind:record-id="ChildRecordData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="High School Graduation Date"
                                           property-name="HighSchoolGraduationDate"
                                           update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                           :required="false"
                                           warning-notice="Entering a date will mark the youth has having graduated high school.  Only enter a date if graduation has already occurred."
                                           global-update="true"
                                           :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">College Graduation Date: </span>
                        <DateEditorRequest v-bind:old-value="ChildRecordData.CollegeGraduationDate"
                                           v-bind:record-id="ChildRecordData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="College Graduation Date"
                                           property-name="CollegeGraduationDate"
                                           update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                           :required="false"
                                           warning-notice="Entering a date will mark the youth has having graduated college.  Only enter a date if graduation has already occurred."
                                           global-update="true"
                                           :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">College Graduation Notes (degree earned, etc.): </span>

                        <TextAreaEditor v-bind:old-value="ChildRecordData.CollegeGraduationNotes"
                                        v-bind:record-id="ChildRecordData.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="College Graduation Notes"
                                        property-name="CollegeGraduationNotes"
                                        update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                        :required="false"
                                        global-update="true"
                                        :chart-id="ChildRecordData.Id" />
                    </p>
                </div>
            </div>
        </div>
        <div v-if="IsPNWILS" class="row">
            <div class="col col-md-6">
                <div class="record-section" style="height:100%;">
                    <h4>PNW ILS Housing Key Info</h4>
                    <p>
                        <span class="bold">Sexual Orientation: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.SexualOrientation"
                                      v-bind:old-value-text="ChildRecordData.SexualOrientation"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Sexual Orientation"
                                      property-name="SexualOrientation"
                                      update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id"
                                      v-bind:options="[{text:'', value:null},{text:'Straight', value:'Straight'},{text:'LGBQA', value:'LGBQA'},{text:'Unknown', value:'Unknown'},{text:'Decline Response', value:'Decline Response'},{text:'N/A', value:'N/A'}]" />
                    </p>
                    <p>
                        <span class="bold">Tribal Affiliation: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.TribalAffiliation"
                                      v-bind:old-value-text="ChildRecordData.TribalAffiliation"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Tribal Affiliation"
                                      property-name="TribalAffiliation"
                                      update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id"
                                      v-bind:options="[{text:'', value:null},{text:'Possible', value:'Possible'},{text:'Yes', value:'Yes'},{text:'No', value:'No'}]" />
                    </p>
                    <p>
                        <span class="bold">Housing Referral Source: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.HousingReferralSource"
                                      v-bind:old-value-text="ChildRecordData.HousingReferralSource"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Housing Referral Source"
                                      property-name="HousingReferralSource"
                                      update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id"
                                      v-bind:options="[{text:'', value:null},{text:'Attorney', value:'Attorney'},{text:'Behavioral Health Organization', value:'Behavioral Health Organization'},{text:'Community Based Organization', value:'Community Based Organization'},{text:'Coordinated Entry', value:'Coordinated Entry'},{text:'DCYF Caseworker', value:'DCYF Caseworker'},{text:'DCYF Contracted Provider', value:'DCYF Contracted Provider'},{text:'DSHS DDA Services', value:'DSHS DDA Services'},{text:'DSHS Economic Services', value:'DSHS Economic Services'},{text:'Family Court', value:'Family Court'},{text:'Friend or Acquaintance', value:'Friend or Acquaintance'},{text:'Guardian Ad Litem', value:'Guardian Ad Litem'},{text:'Juvenile Rehabilitation', value:'Juvenile Rehabilitation'},{text:'Juvenile Court', value:'Juvenile Court'},{text:'Juvenile Detention or Probation', value:'Juvenile Detention or Probation'},{text:'Legal Guardian', value:'Legal Guardian'},{text:'Office of Public Defense', value:'Office of Public Defense'},{text:'Other Family Member', value:'Other Family Member'},{text:'Parent Ally', value:'Parent Ally'},{text:'Public Housing Authority', value:'Public Housing Authority'},{text:'Self', value:'Self'},{text:'YYAHRT', value:'YYAHRT'}]" />
                    </p>
                    <p>
                        <span class="bold">Program Type: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.ProgramType"
                                      v-bind:old-value-text="ChildRecordData.ProgramType"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Program Type"
                                      property-name="ProgramType"
                                      update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id"
                                      v-bind:options="[{text:'', value:null},{text:'FUP', value:'FUP'},{text:'FYI', value:'FYI'},{text:'One-time Supportive Services', value:'One-time Supportive Services'},{text:'Ongoing Case Management', value:'Ongoing Case Management'}]" />
                    </p>
                    <p>
                        <span class="bold">Change in Housing Status From Referral to Exit: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.ChangeInReferralStatusFromReferralToExit"
                                      v-bind:old-value-text="ChildRecordData.ChangeInReferralStatusFromReferralToExit"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Change in Housing Status From Referral to Exit"
                                      property-name="ChangeInReferralStatusFromReferralToExit"
                                      update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id"
                                      v-bind:options="[{text:'', value:null},{text:'Remained Inadequately Housed', value:'Remained Inadequately Housed'},{text:'Achieved Temporary Housing', value:'Achieved Temporary Housing'},{text:'Achieved Permanent Housing', value:'Achieved Permanent Housing'}]" />
                    </p>
                    <p>
                        <span class="bold">PHA: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.PHA"
                                      v-bind:old-value-text="ChildRecordData.PHA"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="PHA"
                                      property-name="PHA"
                                      update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id"
                                      v-bind:options="[
                                          {text:'', value:null},
                                          {text:'Grays Harbor County HA', value:'Grays Harbor County HA'},
                                          {text:'Anacortes HA', value:'Anacortes HA'},
                                          {text:'Bellingham HA', value:'Bellingham HA'},
                                          {text:'Whatcom County HA', value:'Whatcom County HA'},
                                          {text:'Bremerton HA', value:'Bremerton HA'},
                                          {text:'Skagit County HA', value:'Skagit County HA'},
                                          {text:'Asotin County HA', value:'Asotin County HA'},
                                          {text:'Island County HA', value:'Island County HA'},
                                          {text:'Everett HA', value:'Everett HA'},
                                          {text:'Snohomish County HA', value:'Snohomish County HA'},
                                          {text:'Kelso HA', value:'Kelso HA'},
                                          {text:'Kennewick HA', value:'Kennewick HA'},
                                          {text:'Longview HA', value:'Longview HA'},
                                          {text:'Lummi Nation HA', value:'Lummi Nation HA'},
                                          {text:'Grant County HA', value:'Grant County HA'},
                                          {text:'Thurston County HA', value:'Thurston County HA'},
                                          {text:'Okanogan County HA', value:'Okanogan County HA'},
                                          {text:'Othello HA', value:'Othello HA'},
                                          {text:'Pasco/Franklin HA', value:'Pasco/Franklin HA'},
                                          {text:'Peninsula Housing Authority', value:'Peninsula Housing Authority'},
                                          {text:'Renton HA', value:'Renton HA'},
                                          {text:'King County HA', value:'King County HA'},
                                          {text:'Seattle HA', value:'Seattle HA'},
                                          {text:'Sedro Wolley HA', value:'Sedro Wolley HA'},
                                          {text:'Kitsap County HA', value:'Kitsap County HA'},
                                          {text:'Spokane HA', value:'Spokane HA'},
                                          {text:'Sunnyside HA', value:'Sunnyside HA'},
                                          {text:'Tacoma HA', value:'Tacoma HA'},
                                          {text:'Pierce County HA', value:'Pierce County HA'},
                                          {text:'Columbia Gorge HA', value:'Columbia Gorge HA'},
                                          {text:'Vancouver HA', value:'Vancouver HA'},
                                          {text:'Walla Walla HA', value:'Walla Walla HA'},
                                          {text:'Chelan/Wenatchee HA', value:'Chelan/Wenatchee HA'},
                                          {text:'Yakima County HA', value:'Yakima County HA'},
                                          {text:'Not Applicable', value:'Not Applicable'}
                                      ]" />
                    </p>
                    <p>
                        <span class="bold">PHA Voucher Status: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.PHAVoucherStatus"
                                      v-bind:old-value-text="ChildRecordData.PHAVoucherStatus"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="PHA Voucher Status"
                                      property-name="PHAVoucherStatus"
                                      update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id"
                                      v-bind:options="[
                                          {text: '', value:null},
                                          {text: 'Did Not Apply', value: 'Did Not Apply'},
                                          {text: 'Application in Progress', value: 'Application in Progress'},
                                          {text: 'Application Submitted', value: 'Application Submitted'},
                                          {text: 'Voucher Awarded', value: 'Voucher Awarded'},
                                          {text: 'Voucher In Use', value: 'Voucher In Use'},
                                          {text: 'Denied Based on PHA Eligibility', value: 'Denied Based on PHA Eligibility'},
                                          {text: 'Waitlisted, No Voucher Available', value: 'Waitlisted, No Voucher Available'},
                                          {text: 'Unknown', value: 'Unknown'}
                                      ]" />
                    </p>
                    <p>
                        <span class="bold">Housing Navigation: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.HousingNavigation"
                                      v-bind:old-value-text="ChildRecordData.HousingNavigation"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Housing Navigation"
                                      property-name="HousingNavigation"
                                      update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id"
                                      v-bind:options="[
                      {text: '', value:null},
                      {text: 'Yes', value: 'Yes'},
                      {text: 'No', value: 'No'}
                        ]" />
                    </p>
                    <p>
                        <span class="bold">Logistical and Financial Support: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.LogisticalAndFinancialSupport"
                                      v-bind:old-value-text="ChildRecordData.LogisticalAndFinancialSupport"
                                      v-bind:record-id="ChildRecordData.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Logistical and Financial Support"
                                      property-name="LogisticalAndFinancialSupport"
                                      update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                      :chart-id="ChildRecordData.Id"
                                      v-bind:options="[
                      {text: '', value:null},
                      {text: 'Yes', value: 'Yes'},
                      {text: 'No', value: 'No'}
                  ]" />
                    </p>
                </div>
            </div>
            <div class="col col-md-6">
                <div class="record-section" style="height:100%;">
                    <h4>PNW ILS Housing Key Dates</h4>
                    <p>
                        <span class="bold">Housing Referral Date: </span>
                        <DateEditorRequest v-bind:old-value="ChildRecordData.HousingReferralDate"
                                           v-bind:record-id="ChildRecordData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Housing Referral Date"
                                           property-name="HousingReferralDate"
                                           update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                           :required="false"
                                           global-update="true"
                                           :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">Referral Child Welfare Certification Date: </span>
                        <DateEditorRequest v-bind:old-value="ChildRecordData.ReferralChildWelfareCertificationDate"
                                           v-bind:record-id="ChildRecordData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Referral Child Welfare Certification Date"
                                           property-name="ReferralChildWelfareCertificationDate"
                                           update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                           :required="false"
                                           global-update="true"
                                           :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">Certification Date: </span>
                        <DateEditorRequest v-bind:old-value="ChildRecordData.CertificationDate"
                                           v-bind:record-id="ChildRecordData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Certification Date"
                                           property-name="CertificationDate"
                                           update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                           :required="false"
                                           global-update="true"
                                           :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">Start of Services Date (Start of Prelease services date): </span>
                        <DateEditorRequest v-bind:old-value="ChildRecordData.StartOfServicesDate"
                                           v-bind:record-id="ChildRecordData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Start of Services Date"
                                           property-name="StartOfServicesDate"
                                           update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                           :required="false"
                                           global-update="true"
                                           :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">Completed Application Date with PHA: </span>
                        <DateEditorRequest v-bind:old-value="ChildRecordData.CompletedApplicationDateWithPHA"
                                           v-bind:record-id="ChildRecordData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Completed Application Date with PHA"
                                           property-name="CompletedApplicationDateWithPHA"
                                           update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                           :required="false"
                                           global-update="true"
                                           :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">Voucher Issuance Date: </span>
                        <DateEditorRequest v-bind:old-value="ChildRecordData.VoucherIssuanceDate"
                                           v-bind:record-id="ChildRecordData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Voucher Issuance Date"
                                           property-name="VoucherIssuanceDate"
                                           update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                           :required="false"
                                           global-update="true"
                                           :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">Date Certified Referral Sent to PHA: </span>
                        <DateEditorRequest v-bind:old-value="ChildRecordData.DateCertifiedReferralSentToPHA"
                                           v-bind:record-id="ChildRecordData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Date Certified Referral Sent to PHA"
                                           property-name="DateCertifiedReferralSentToPHA"
                                           update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                           :required="false"
                                           global-update="true"
                                           :chart-id="ChildRecordData.Id" />
                    </p>
                    <p>
                        <span class="bold">Lease Up Date (Postlease Date): </span>
                        <DateEditorRequest v-bind:old-value="ChildRecordData.LeaseUpDate"
                                           v-bind:record-id="ChildRecordData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Lease Up Date"
                                           property-name="LeaseUpDate"
                                           update-method="Tay/Clients/UpdateClientSubProgramMembership"
                                           :required="false"
                                           global-update="true"
                                           :chart-id="ChildRecordData.Id" />
                    </p>


                </div>
            </div>
            </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import DateEditorRequest from '../../../Core/ItemEditors/DateEditorRequest.vue';
    import StringEditor from '../../../Core/ItemEditors/StringEditor.vue';
    import IntegerEditor from '../../../Core/ItemEditors/IntegerEditor.vue';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor.vue';
    import TextAreaEditor from '../../../Core/ItemEditors/TextAreaEditor.vue';
    import DischargeEditor from '../../../Core/ItemEditors/DischargeEditor.vue';
    import SingleMembershipEditor from '../../../Core/ItemEditors/SingleMembershipEditor.vue';
    import PNWILSProgramEditor from '../../../Core/ItemEditors/PNWILSProgramEditor.vue';
    import SchoolDisplayAndEdit from '../../../Core/ItemEditors/SchoolDisplayAndEdit.vue';
    import EmployerDisplayAndEdit from '../../../Core/ItemEditors/EmployerDisplayAndEdit.vue';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                Agencies: [],
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            GetAgencies() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FosterClients/GetAgencies", {}, this.GetAgenciesSuccess, () => { }, false);
            },
            GetAgenciesSuccess(response) {
                this.Agencies = response.data.data;
                for (var i = 0; i < this.Agencies.length; i++) {
                    this.Agencies[i].text = this.Agencies[i].Name;
                    this.Agencies[i].value = this.Agencies[i].Id;
                }
            }
        },
        components: {
            DateEditorRequest,
            StringEditor,
            DischargeEditor,
            SingleMembershipEditor,
            PNWILSProgramEditor,
            TextAreaEditor,
            IntegerEditor,
            EditMode,
            SchoolDisplayAndEdit,
            EmployerDisplayAndEdit,
            SelectEditor
        },
        mounted() {
            this.GetAgencies();
        },
        computed: {
            GetSubProgramTerminationReasons: function () {
                let subprogram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ChildRecordData.SubProgramID);
                let returnObj = [];
                if (subprogram.DischargeReasons.length > 0) {
                    subprogram.DischargeReasons.forEach(function (item) {
                        returnObj.push({ text: item.Label, value: item.Id, grouping: item.Grouping });
                    })
                }
                return returnObj;
            },
            OptionsPlacementType: function () {
                return this.$store.state.Options.PlacementType;
            },
            ProgramServicesCensus: function () {
                return this.ChildRecordData.ProgramServices.filter(ps => ps.ProgramService.ServiceType == "Census");
            },
            PrimaryLanguageSpokenOptions: function () {
                return this.$store.state.Options.PrimaryLanguageSpoken;
            },
            AgencyOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramAgencyOptions"](this.ChildRecordData.SubProgramID);
            },
            CommonSchools: function () {
                return this.$store.getters["Schools.CommonSchools"](this.ChildRecordData.SubProgramID);
            },
            IsPNWILS: function () {
                if (this.ChildRecordData.SubProgramID.toUpperCase() == "EBDA4D2B-FD9C-4135-804E-5132296063CA") {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped>
</style>